<template>
  <div ref="video_container" class="video-interview">
    <CountDownTimer
        class="video-timer"
        ref="countDown"
        :time="3"
        @end_callback="countDownFinished($event)"
        v-bind:pad-numbers="false"
        format="${s}"
      >
      <template v-slot:default="data">
      <span style="
      background-color: #bbb;
      z-index: 1001;
      font-size: 2.8rem;
      color: white;
      margin: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 4rem;
      width: 4rem;
      border-radius: 50%;
    ">
      {{ data.timeString }}
    </span>
      </template>
      </CountDownTimer>
    <div class="video-header valign-wrapper" style="z-index: 1001;">
      <slot name="question"></slot>
    </div>
    <div class="video recorder">
      <a v-show="this.mode == 'recorder' && this.status == 'recording'" @click.prevent="nextQuestion" class="forward" style="z-index:10;"><img src="../assets/forward-icon.png" style="max-height: 35px; width: auto;" alt=""></a>
      <video id="video_recorder" playsinline class="video-js vjs-default-skin">
        <p class="vjs-no-js">
          To view this video please enable JavaScript, or consider upgrading to
          a web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank"
            >supports HTML5 video.</a
          >
        </p>
      </video>
    </div>
    <div class="video-controls" v-show="this.mode == 'recorder'">
      <div v-show="confirmFinish" class="alert orange-pastel rounded" style="
          border-radius: 50px;
          padding-bottom: 10px;
          font-size: 0.7rem;
          margin-left: auto;
          margin-right: auto;
          "><span>¿Confirmas que quieres terminar la entrevista?</span>
          <a @click.prevent="stopInterview()" class="btn-floating btn-small center left" style="
          margin-left: 30%;
      ">Si</a><a @click.prevent="confirmFinish = false" class="btn-floating btn-small center right" style="
          margin-right: 30%;
      ">No</a><span></span>
      </div>
      <a
        v-show="!confirmFinish"
        @click.prevent="confirmStopInterview()"
        class="rounded-icon stop show-more-right show-element-right"
        ><i class="fa fa-stop"></i
      ></a>
      <CountDownTimer
        v-show="!confirmFinish"
        class="video-timer"
        ref="timer"
        :time="question?question.time:6"
        @end_callback="timerStopped($event)"
      ></CountDownTimer>
      <a
        v-show="!confirmFinish" 
        @click="toggleFullscreen()" class="rounded-icon expand">
        <img
          src="../assets/expand-icon.png"
          style="max-height: 24px; width: auto;"
          alt=""
        />
      </a>
    </div>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import "videojs-record/dist/css/videojs.record.css";
import videojs from "video.js";
import "webrtc-adapter";
import RecordRTC from "recordrtc";
import Record from "videojs-record/dist/videojs.record.js";
import FFmpegjsEngine from "videojs-record/dist/plugins/videojs.record.ffmpegjs.js";
import CountDownTimer from "@/components/CountDownTimer.vue";
export default {
  props: ["uploadUrl", "time"],
  components: {CountDownTimer},
  data() {
    return {
      action: "",
      status: "initiating",
      confirmFinish: false,
      recorder: "",
      question: null,
      mode: "recorder",
      fullscreenElementProperty: "",
      fullscreenEnterMethod: "",
      fullscreenExitMethod: "",


      recorderOptions: {
        autoplay: false,
        controls: false,
        bigPlayButton: false,
        controlBar: {
          deviceButton: false,
          recordToggle: false,
          pipToggle: false,
          recordIndicator: true
        },
        width: "100%",
        height: "100%",
        fluid: true,
        aspectRatio: "4:3",
        //fill: true,
        //responsive: true,
        /*
        sources: [
            {
                src:
                    "https://collab-project.github.io/videojs-wavesurfer/demo/media/example.mp4",
                    type: "video/mp4"
            }
        ],
        */
        plugins: {
          record: {
            pip: false,
            audio: true,
            video: true,
            maxLength: 90,
            debug: true
          }
        }
      }
    };
  },
  mounted() {
    const fullscreenElementProperties = [
      "fullscreenElement",
      "webkitFullscreenElement",
      "mozFullScreenElement",
      "msFullscreenElement"
    ];
    for (const idx in fullscreenElementProperties) {
      if (fullscreenElementProperties[idx] in document) {
        this.fullscreenElementProperty = fullscreenElementProperties[idx];
        break;
      }
    }
    const fullscreenEnterMethods = [
      "requestFullscreen",
      "mozRequestFullScreen",
      "webkitRequestFullscreen",
      "msRequestFullscreen"
    ];
    const sampleElement = document.createElement("div");
    for (const idx in fullscreenEnterMethods) {
      if (fullscreenEnterMethods[idx] in sampleElement) {
        this.fullscreenEnterMethod = fullscreenEnterMethods[idx];
        break;
      }
    }
    const fullscreenExitMethods = [
      "exitFullscreen",
      "mozCancelFullScreen",
      "webkitExitFullscreen",
      "msExitFullscreen"
    ];
    for (const idx in fullscreenExitMethods) {
      if (fullscreenExitMethods[idx] in document) {
        this.fullscreenExitMethod = fullscreenExitMethods[idx];
        break;
      }
    }
    this.recorder = videojs("#video_recorder", this.recorderOptions);
    this.recorder.ready(() => {
      // print version information at startup
      const msg =
        "Using video.js " +
        videojs.VERSION +
        " with videojs-record " +
        videojs.getPluginVersion("record") +
        " and recordrtc " +
        RecordRTC.version;
      videojs.log(msg);
      this.recorder.on("deviceReady", this.deviceReady);
      this.recorder.on("deviceError", () => {
        console.log("device error:", this.recorder.deviceErrorCode);
      });
      this.recorder.on("error", (element, error) => {
        console.error(error);
      });
      // user clicked the record button and started recording
      this.recorder.on("startRecord", () => {
        console.log("started recording!");
      });
      // user completed recording and stream is available
      this.recorder.on("finishRecord", this.finishRecord);
      this.recorder.on("ended", this.playbackEnded);
      this.recorder.on("loadeddata", this.loadeddata);
      this.recorder.record().getDevice();
    });
  },
  methods: {
    deviceReady() {
      if (typeof MediaRecorder === "undefined" || !navigator.getUserMedia) {
        console.log("Your browser does not support the Media Recorder API");
      } else {
        console.log("device ready:");
        if (this.status == 'initiating') {
          this.$emit("recorderReady");
        } else if(this.status == 'countdown') {
          this.record();
        }
      }
    },
    loadeddata(event) {
      console.log("loadeddata: ", event);
      console.log("loadeddata: ", this.recorder.currentSrc());
      console.log("loadeddata: " + this.status);
      if(this.status == 'asking') {
        this.$nextTick(function(){
          this.playQuestionVideo('asking')
        });
      } else if (this.status == 'playing') {
        this.$nextTick(function(){
          this.playQuestionVideo('playing')
        });
      }
    },
    finishRecord() {
      // the blob object contains the recorded data that
      // can be downloaded by the user, stored on server etc.
      console.log("finished recording: [ " + this.status + " ] ", this.recorder.recordedData);
      if (this.status == 'recording') {
        this.status = 'stopped';
        this.$emit("recordingFinished", {question: this.question, recording: this.recorder.recordedData, action: this.action});
      }
    },
    playbackEnded(event) {
      console.log("playbackEnded: " + event);
      if (this.status == 'asking') {
        this.countDown();
      }
    },
    
    playAnswer(blob) {
      const recordingUrl = window.URL.createObjectURL(blob);
      const recordingType = "video/webm"; //blob.type;
      const newStatus = "playing";
      console.log("Blob Type:" + recordingType + " URL:" + recordingUrl);
      this.loadQuestionVideo(recordingUrl, recordingType, newStatus);
    },
    record() {
      this.status = 'recording';
      this.recorder.record().start();
      this.$refs.timer.startCounter();
    },
    ask(question) {
      this.action = '';
      console.log(question.question);
      this.question = question;
      this.loadQuestionVideo(this.question.video, "video/mp4", 'asking');
    },
    loadQuestionVideo(url, type, newStatus) {
      console.log("loadQuestionVideo: " + this.status);
      this.status = newStatus;
      this.recorder.record().reset();
      //this.recorder.src({ src: "https://collab-project.github.io/videojs-wavesurfer/demo/media/example.mp4", type: "video/mp4"});
      //this.recorder.src({ src: "https://firebasestorage.googleapis.com/v0/b/evoluq-staging.appspot.com/o/interviews%2Fquestions%2Fcomo_mides_tu_impacto_en_tu_trabajo.mp4?alt=media&token=7ad4f0a9-b5c4-45f5-aea4-b899aae03315", type: "video/mp4"});
      this.recorder.src({ src: url, type: type});
    },
    playQuestionVideo(newStatus) {
      console.log("playQuestionVideo:" + newStatus);
      this.status = newStatus;
      this.recorder.play();
    },
    countDown() {
      console.log("countDown");
      this.status = 'countdown';
      this.$refs.countDown.startCounter();
    },
    countDownFinished() {
      console.log("countDownFinished");
      this.startRecording();
    },
    startRecording() {
      console.log("startRecording");
      this.recorder.record().reset();
      this.recorder.record().getDevice();
    },
    stopRecording() {
      console.log("stopRecording");
      this.$refs.timer.stopCounter();
      //this.recorder.record().stop();
    },
    timerStopped(event) {
      console.log("timerStopped");
      //this.stopRecording();
      this.recorder.record().stop();
    },
    changeMode(mode) {
      this.mode = mode;
    },
    toggleFullscreen() {
      console.log("fullscreenElementProperty:" + this.fullscreenElementProperty);
      console.log("fullscreenExitMethod:" + this.fullscreenExitMethod);
      console.log("fullscreenEnterMethod:" + this.fullscreenEnterMethod);
      if (document[this.fullscreenElementProperty]) {
        document[this.fullscreenExitMethod]();
        console.log("EXIT FULLSCREEN");
      } else {
        this.$refs.video_container[this.fullscreenEnterMethod]();
        console.log("ENTER FULLSCREEN");
      }
    },
    nextQuestion() {
      this.$refs.countDown.stopCounter();
      if (this.status == 'recording') {
        this.stopRecording();
        this.recorder.record().stop();
      } else {
        this.$emit("recordingFinished", {question: this.question, recording: null});
        this.recorder.record().reset();
      }
    },
    confirmStopInterview() {
      this.confirmFinish = true;
    },
    stopInterview() {
      this.action = 'stop_interview';
      this.$refs.countDown.stopCounter();
      if (this.status == 'recording') {
        this.stopRecording();
        this.recorder.record().stop();
      } else {
        this.$emit("recordingFinished", {question: this.question, recording: null, action: this.action});
        this.recorder.record().reset();
      }
    },



    submitVideo() {
      this.isSaveDisabled = true;
      this.isRetakeDisabled = true;
      const data = this.recorder.recordedData;
      const formData = new FormData();
      formData.append("video", data, data.name);
      this.submitText = "Uploading " + data.name;
      console.log("uploading recording:", data.name);
      this.recorder.record().stopDevice();
      fetch(this.uploadUrl, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-TOKEN": document
            .querySelector('meta[name="csrf-token"]')
            .attr("content")
        }
      })
        .then(success => {
          console.log("recording upload complete.");
          this.submitText = "Upload Complete";
        })
        .catch(error => {
          console.error("an upload error occurred!");
          this.submitText = "Upload Failed";
        });
    }
  },
  beforeDestroy() {
    if (this.recorder) {
      //this.recorder.record().stopDevice();
      //this.recorder.record().stop();
      //this.recorder.record().stopStream();
      this.recorder.dispose();
    }
  }
};
</script>